import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextAccounting } from '../Accounting';
import { Company } from '../../../../models/company.model';
import { BookingJournalDA } from '../../../../services/admin/booking.journal.service';
import { GlobalSwal } from '../../../../styles/swal.style';
import { CompanyBookingJournals } from '../../../../models/company.booking.journals.model';
import { AccountingAccount } from '../../../../models/accounting.account.model';
import { Error } from '../../../../models/error.model';
import { BookingJournal } from '../../../../models/booking.journal.model';
import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { getError } from '../../../../languages/translations/response';
import { Settings } from '../../../../models/settings.model';
import { errorWebHandler } from '../../../../scripts/error.web.handler.script';

export interface JournalPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  companyForUser: Company | null,
  settingsForCompany: Settings | null,
  accountingAccountsForCompany: AccountingAccount[] | null,
  bookingJournalsForCompany: BookingJournal[] | null,
  setBookingJournalsForCompany: Dispatch<SetStateAction<BookingJournal[] | null>>,
  loadBookingJournalsForCompany: Function
};

let errorResponse: Error, bookingJournalsResponse: CompanyBookingJournals;

const JournalPage: React.FunctionComponent<JournalPageProps> = props => {
  const {setRoute, companyForUser, settingsForCompany, accountingAccountsForCompany} = UseOutletContextAccounting()
  const {lang} = StateLanguage()

  const [bookingJournalsForCompany, setBookingJournalsForCompany] = useState<BookingJournal[] | null>(null)

  const loadBookingJournalsForCompany = async (id_company: string) => {
    await BookingJournalDA.getBookingJournals(id_company, '', '', '').then( (response) => {
      if (response.status === 200) {
        const raw = response.data
        let journals: BookingJournal[]
        if (Array.isArray(raw)) {
          journals = raw
        } else if (raw?.items && Array.isArray(raw.items)) {
          journals = raw.items
        } else if (raw?.booking_journals) {
          journals = raw.booking_journals
        } else {
          journals = []
        }
        setBookingJournalsForCompany(journals)
      } else {
        errorResponse = response.data

        GlobalSwal.fire({
          title: getError(errorResponse.code, lang.code, errorResponse.message),
          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
          icon: 'error',
          confirmButtonText: lang.labels.okGotIt
        })
      }
    }).catch( (error) => {
      errorWebHandler(lang, error)
    })
  }

  useEffect( () => {
    if (companyForUser) {
      loadBookingJournalsForCompany(companyForUser.id)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyForUser])

  return (
    <Outlet context={{setRoute, companyForUser, settingsForCompany, accountingAccountsForCompany, bookingJournalsForCompany, setBookingJournalsForCompany, loadBookingJournalsForCompany}}></Outlet>
  );
}

export function UseOutletContextJournal() {
  return useOutletContext<ContexType>()
};

export default JournalPage;
